import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/** Keeps an opted-in product heading in sync with the server-rendered selected style. */
class ProductStyleTitle extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(ThemeEvents.variantUpdate, this.#updateTitle, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }

  /** @param {import('./events').VariantUpdateEvent} event */
  #updateTitle = (event) => {
    if (String(event.detail.data.productId) !== this.dataset.productId) return;
    const source = event.detail.data.html?.getElementById(this.id);
    if (!source) return;
    this.replaceChildren(...source.cloneNode(true).childNodes);
  };
}

if (!customElements.get('product-style-title')) {
  customElements.define('product-style-title', ProductStyleTitle);
}
